<script>
import Multiselect from "vue-multiselect";
import Swal from "sweetalert2";
import router from "@/router";

import RadioBox from "@/components/radio-box";

import {
  required,
  email,
  maxLength
} from "vuelidate/lib/validators";

export default {
  components: {
    RadioBox,
    Multiselect
  },
  props: {
    update: {
      type: Boolean,
      default: false
    },
    proposal: {
      type: Object,
      default: null
    }
  },
  async mounted() {
    this.apiGet(`/advertisers`, { exclude: 'agentImage,businessAddress,businessType,logoImage' }, true).then((data) => {
      this.advertiserOptions = data.data;
    }).catch((error) => {
      this.$store.dispatch('layout/addPageError', error);
    })

    this.apiGet(`/packages`, {}, true).then((data) => {
      this.packageOptions = data.data;
    }).catch((error) => {
      this.$store.dispatch('layout/addPageError', error);
    })

    this.apiGet(`/mastheads`, { exclude: 'logoImage' }, true).then((data) => {
      this.mastheadOptions = data.data;
    }).catch((error) => {
      this.$store.dispatch('layout/addPageError', error);
    })

    if (this.update && this.proposal) {
      this.form.name = this.proposal.name
      this.form.clientEmail = this.proposal.clientEmail
      this.form.advertiser = this.proposal.advertiser.id

      this.form.packages = this.proposal.packages.length ? this.proposal.packages.map((e) => e.id) : [];

      this.share.email = this.form.clientEmail
    }

    if (this.$route.query.shareForm) {
      this.$refs['share-modal'].show()
    }

    if (this.$route.query.advertiser) {
      this.form.advertiser = this.$route.query.advertiser;
    }
  },
  data() {
    return {
      link: process.env.VUE_APP_DASHBOARD_URL,
      hasError: false,
      errors: null,
      creating: false,
      submitted: false,
      optionSubmitted: false,
      emailSubmitted: false,
      type: null,
      advertiserOptions: [],
      packageOptions: [],
      mastheadOptions: [],
      packageLevels: [
        'Diamond',
        'Gold',
        'Platinum',
        'Silver',
      ],
      masthead: '',
      option: {
        package: '',
      },
      form: {
        name: '',
        advertiser: '',
        clientEmail: '',
        packages: []
      },
      share: {
        email: '',
        dismissCountDown: 0,
      }
    }
  },
  methods: {
    resetForm() {
      this.option = {
        package: '',
        masthead: ''
      }

      this.submitted = false;
    },
    handleCreate(status) {
      this.submitted = true;

      this.$v.form.$touch();

      if (!this.$v.form.$invalid) {
        this.type = 'create';
        this.creating = true;

        this.apiPost(`/proposals`, { ...this.form, status: status }).then((id) => {
          this.creating = false;
          Swal.fire({
            title: `You have successfully added ${this.form.name}`,
            icon: 'success',
            showCancelButton: true,
            confirmButtonText: 'Back Home',
            cancelButtonText: 'Share Proposal',
            confirmButtonColor: "#1D99C7",
            allowOutsideClick: false,
            allowEscapeKey: false
          }).then(result => {
            if (result.value) {
              router.push({ path: '/proposals' });
            } else {
              router.push({ path: `/proposals/${id}/edit?shareForm=true` });
            }
          });
        }).catch((error) => {
          this.creating = false;

          if (error) {
            this.hasError = true;
            this.errors = error.response ? error.response.data.error.message : null;
          }
        })
      }
    },
    handleUpdate(status) {
      this.submitted = true;
      
      this.$v.form.$touch();

      if (!this.$v.form.$invalid) {
        this.type = 'update'
        this.creating = true;

        this.apiPatch(`/proposals/${this.proposal.id}`, { ...this.form, status: status }).then(() => {
          this.creating = false;
          Swal.fire({
            title: `You have updated ${this.form.name}`,
            icon: 'success',
            confirmButtonText: 'Back Home',
            confirmButtonColor: "#1D99C7",
            allowOutsideClick: false,
            allowEscapeKey: false
          }).then(result => {
            if (result.value) {
              router.push({ path: '/proposals' });
            }
          });
        }).catch((error) => {
          this.creating = false;

          if (error) {
            this.hasError = true;
            this.errors = error.response ? error.response.data.error.message : null;
          }
        })
      }
    },
    sendEmail() {
      this.emailSubmitted = true;

      this.$v.share.$touch();

      if (this.proposal && !this.$v.share.$invalid) {
        this.$refs['share-modal'].hide()
        
        this.apiPost(`/proposals/${this.proposal.id}/send`, { email: this.share.email }).then(() => {
          this.$bvToast.toast(`A proposal email has been sent to ${this.share.email}`, {
            title: 'Proposal email sent',
            variant: 'success',
            solid: true
          });

          this.share.email = '';

          this.$v.share.$reset();
        }).catch(() => {
          this.$bvToast.toast('Proposal email couldn\'t be sent because an error error has occurred', {
            title: 'Error sending email',
            variant: 'warning',
            solid: true
          });

          this.share.email = '';

          this.$v.share.$reset();
        })
      }
    },
    addOption() {
      this.optionSubmitted = true

      this.$v.option.$touch()

      if (!this.$v.option.$invalid) {
        this.form.packages.push(this.option.package)

        this.$v.option.$reset();
        this.resetForm();
      }
    },
    deleteOption (index) {
      const array = this.form.packages

      if (index >  -1) {
        array.splice(index, 1)

        this.form.packages = array
      }
    },
    copyLink() {
      this.$copyText(this.link)
    },
    packageByIndex(index) {
      return this.packageOptions.find((packageObject) => packageObject.id === this.form.packages[index])
    },
    countDownChanged(dismissCountDown) {
      this.share.dismissCountDown = dismissCountDown
    },
    handleAdvertiserSelect(advertiser) {
      this.form.advertiser = advertiser.id;
      this.form.clientEmail = advertiser.contactEmail;
    },
    packagesByMasthead(masthead) {
      return this.packageOptions.filter((option) => option.masthead.id === masthead)
    },
    handleMastheadSelect({ id }) {
      this.masthead = id

      this.option.package = ''
    },
    packageLevelText(packageValue, level) {
      if (packageValue && packageValue.level === level) {
        return `${this.$options.filters.formatCurrency(packageValue.price)} ex GST </br> ${this.$options.filters.formatNumberWithCommas(packageValue.masthead.impactsPerInsertion)} Impacts` 
      }
    }
  },
  computed: {
    packageValue() {
      return this.packageOptions ? this.packageOptions.find((packageObject) => packageObject.id === this.option.package) : null
    },
    advertiserValue() {
      return this.advertiserOptions ? this.advertiserOptions.find((advertiser) => advertiser.id === this.form.advertiser) : null
    },
    mastheadValue() {
      return this.mastheadOptions ? this.mastheadOptions.find((masthead) => masthead.id === this.masthead) : null
    }
  },
  validations: {
    form: {
      name: { required, maxLength: maxLength(150) },
      advertiser: { required },
      clientEmail: { required, email },
      packages: { required }
    },
    option: {
      package: { required },
    },
    share: {
      email: { required, email }
    }
  },
}
</script>

<template>
  <div class="row">
    <div class="col-12 col-md-3">
      <div class="card">
        <div class="card-body">
          <h3>Proposal Configuration</h3>
          <p>Create and manage proposals for Advertisers quickly and easily. Each proposal can feature a range of campaign options to review and can be downloaded in PDF or sent directly to the advertiser via a secure link.</p>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-9">
      <div class="card">
        <div class="card-body">
          <b-form-group>
            <label for="name">Proposal Name</label>
            <b-form-input id="name" name="name" type="text" v-model="form.name" placeholder="Enter Proposal Name" :class="{ 'is-invalid': submitted && $v.form.name.$error }" />
            <div v-if="submitted && $v.form.name.$error" class="invalid-feedback">
              <span v-if="!$v.form.name.required">This value is required.</span>
              <span v-if="!$v.form.name.maxLength">This value must not exceed {{ $v.form.name.$params.maxLength.max }} characters.</span>
            </div>
          </b-form-group>
          <b-form-group>
            <div class="d-flex align-items-center justify-content-between">
              <label for="advertiser">Advertiser</label>
              <b-button variant="link" class="p-0" v-b-popover.left="'You must enter an Advertiser Profile before you can create a Proposal for them. It is important all content in the profile is completed as the Proposal inherits a lot of this information.'">
                <i class="bx bxs-info-circle font-size-24"></i>
              </b-button>
            </div>
            <multiselect
              :class="{ 'is-invalid': submitted && $v.form.advertiser.$error }"
              :options="advertiserOptions"
              :value="advertiserValue"
              @select="handleAdvertiserSelect"
              deselect-label=""
              label="businessName"
              select-label=""
              track-by="id"
            ></multiselect>
            <div v-if="submitted && $v.form.advertiser.$error" class="invalid-feedback">
              <span v-if="!$v.form.advertiser.required">This value is required.</span>
            </div>
          </b-form-group>
          <b-form-group>
            <label for="clientEmail">Client Email</label>
            <b-form-input id="clientEmail" name="clientEmail" type="email" v-model="form.clientEmail" placeholder="Enter Client Email" :class="{ 'is-invalid': submitted && $v.form.clientEmail.$error }" />
            <div v-if="submitted && $v.form.clientEmail.$error" class="invalid-feedback">
              <span v-if="!$v.form.clientEmail.required">This value is required.</span>
              <span v-if="!$v.form.clientEmail.email">Please enter valid email.</span>
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="card">
        <div class="card-body" v-if="form.packages.length < 5" :class="{ 'proposals__form-wrapper' : form.packages.length }">
          <div class="row">
            <div class="col-12 col-xl-8">
              <b-form @submit.prevent="addOption">
                <b-form-group v-if="mastheadOptions && mastheadOptions.length">
                  <label for="masthead">Masthead</label>
                  <multiselect
                    :options="mastheadOptions"
                    :value="mastheadValue"
                    @select="handleMastheadSelect"
                    deselect-label=""
                    label="name"
                    select-label=""
                    track-by="id"
                  ></multiselect>
                </b-form-group>
                <b-form-group v-if="packageOptions && packageOptions.length">
                  <label for="package">Package</label>
                  <multiselect
                    :class="{ 'is-invalid': optionSubmitted && $v.option.package.$error }"
                    :disabled="!this.masthead"
                    :options="packagesByMasthead(this.masthead)"
                    :value="packageValue"
                    @select="({ id }) => this.option.package = id"
                    deselect-label=""
                    label="name"
                    select-label=""
                    track-by="id"
                  ></multiselect>
                  <div v-if="optionSubmitted && $v.option.package.$error" class="invalid-feedback">
                    <span v-if="!$v.option.package.required">This value is required.</span>
                  </div>
                </b-form-group>
                <div class="row">
                  <div class="col-12 col-md-12">
                    <b-form-group>
                      <label for="type" class="card-title">Type</label>
                      <div class="row">
                        <div class="col-4">
                          <radio-box
                            :disabled="!option.package || (packageValue && packageValue.type !== 'Print & digital')"
                            title="Print & digital"
                            icon="bxs-news"
                            text="Package will include both Print & digital Channels."
                            id="digitalPrint"
                            name="type"
                            value="Print & digital"
                            :model-value="packageValue ? packageValue.type : null"
                          />
                        </div>
                        <div class="col-4">
                          <radio-box
                            :disabled="!option.package || (packageValue && packageValue.type !== 'Digital')"
                            title="Digital"
                            icon="bxs-pointer"
                            text="Package will include only Digital Channels."
                            id="digital"
                            name="type"
                            value="Digital"
                            :model-value="packageValue ? packageValue.type : null"
                          />
                        </div>
                        <div class="col-4">
                          <radio-box
                            :disabled="!option.package || (packageValue && packageValue.type !== 'Video')"
                            title="Video"
                            icon="bxs-video"
                            text="Package will include only Video Channels."
                            id="video"
                            name="type"
                            value="Video"
                            :model-value="packageValue ? packageValue.type : null"
                          />
                        </div>
                      </div>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <b-form-group>
                      <label for="objective" class="card-title">Objective</label>
                      <div class="row">
                        <div class="col-4">
                          <radio-box
                            :disabled="!option.package || (packageValue && packageValue.objective !== 'Awareness')"
                            title="Awareness"
                            icon="bxs-user"
                            text="Drive Reach and Awareness"
                            id="awareness"
                            name="objective"
                            value="Awareness"
                            :model-value="packageValue ? packageValue.objective : null"
                          />
                        </div>
                        <div class="col-4">
                          <radio-box
                            :disabled="!option.package || (packageValue && packageValue.objective !== 'Leads')"
                            title="Leads"
                            icon="bxs-phone"
                            text="Drive Actions including Leads and Calls"
                            id="Leads"
                            name="objective"
                            value="Leads"
                            :model-value="packageValue ? packageValue.objective : null"
                          />
                        </div>
                      </div>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <b-form-group>
                      <label for="campaigns" class="card-title">Campaigns</label>
                      <div class="row">
                        <div class="col-3" v-for="packageLevel in packageLevels" :key="packageLevel">
                          <radio-box
                            :disabled="!option.package || (packageValue && packageValue.level !== packageLevel)"
                            :title="packageLevel"
                            inline
                            :text="packageLevelText(packageValue, packageLevel)"
                            :id="packageLevel"
                            :value="packageLevel"
                            name="campaigns"
                            :model-value="packageValue ? packageValue.level : null"
                          />
                          <button v-if="packageValue && packageValue.level === packageLevel" v-b-modal.packages-modal type="button" class="btn btn-link d-flex align-items-center p-0">
                            View package details
                          </button>
                        </div>
                      </div>
                      <b-modal id="packages-modal" centered size="lg">
                        <template v-slot:modal-header="{ close }">
                          <div class="w-100 d-flex justify-content-center">
                            <div class="text-center">
                              <img v-if="packageValue.masthead.logoImage" :src="packageValue.masthead.logoImage.url" alt="" class="mb-2" style="height: 50px" />
                              <h3 class="text-capitalize">{{ packageValue.objective }} {{ packageValue.level }}</h3>
                            </div>
                            <b-button size="sm" variant="link" @click="close()" class="position-absolute top-0 right-0">
                              <i class="bx bx-x font-size-24 text-dark"></i>
                            </b-button>
                          </div>
                        </template>
                        <div class="row w-75 mx-auto" v-if="packageValue">
                          <div class="col-6 d-flex" v-if="packageValue.type === 'Print & digital'">
                            <div class="mx-auto d-inline-block">
                              <h5>Print Impacts: <span class="d-block mt-2">{{ packageValue.type === 'Print & digital' ? packageValue.masthead.totalImpacts : null | formatNumberWithCommas }}</span></h5>
                              <ul class="list-unstyled">
                                <li>
                                  <label class="font-size-14 d-flex align-items-center">
                                    <i class="bx bxs-checkbox-checked text-primary mr-2 font-size-24"></i>
                                    {{ packageValue.totalInsertions }} x {{ packageValue.printSize }} page Insertions
                                  </label>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div class="col-6 d-flex" v-if="packageValue">
                            <div class="mx-auto d-inline-block">
                              <h5>Digital Impressions: <span class="d-block mt-2">{{ packageValue.impressions | formatNumberWithCommas }}</span></h5>
                              <ul class="list-unstyled" v-if="packageValue.digitalChannels">
                                <li class="mb-2" v-for="digitalChannel in packageValue.digitalChannels" :key="digitalChannel">
                                  <label class="font-size-14 d-flex align-items-center">
                                    <i class="bx bxs-checkbox-checked text-primary mr-2 font-size-24"></i>
                                    {{ digitalChannel }}
                                  </label>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </b-modal>
                    </b-form-group>
                    <b-button variant="primary" class="btn-block mt-3" size="lg" type="submit">Add</b-button>
                  </div>
                </div>
              </b-form>
            </div>
          </div>
        </div>
        <div v-if="form.packages.length && packageOptions.length" class="proposals__list-wrapper">
          <div class="card-body">
            <div v-for="(option, index) in form.packages" :key="index" class="card bg-light mt-2">
              <div class="card-head">
                <div>
                  <b-button variant="danger" class="w-md" @click="() => deleteOption(index)">
                    <i class="bx bx-trash-alt font-size-16 align-middle mr-2"></i>
                    Delete Option
                  </b-button>
                </div>
              </div>
              <div class="card-body" v-if="packageByIndex(index)">
                <div class="row">
                  <div class="col-4">
                    <h6>Package</h6>
                    <p>{{ packageByIndex(index).name }}</p>
                  </div>
                  <div class="col-4">
                    <h6>Type</h6>
                    <p>{{ packageByIndex(index).type }}</p>
                  </div>
                  <div class="col-4">
                    <h6>Objective</h6>
                    <p>{{ packageByIndex(index).objective }}</p>
                  </div>
                  <div class="col-4">
                    <h6>Campaigns</h6>
                    <p>{{ packageByIndex(index).level }}</p>
                  </div>
                  <div class="col-4" v-if="packageByIndex(index).type === 'Print & digital'">
                    <h6>Print Insertions</h6>
                    <p>{{ packageByIndex(index).totalInsertions }}</p>
                  </div>
                  <div class="col-4" v-if="packageByIndex(index).type === 'Print & digital'">
                    <h6>Print Impacts</h6>
                    <p>{{ packageByIndex(index).totalImpacts | formatNumberWithCommas }}</p>
                  </div>
                  <div class="col-4">
                    <h6>Digital Impressions</h6>
                    <p>{{ packageByIndex(index).impressions | formatNumberWithCommas }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="this.update">
              <b-button variant="secondary" v-b-modal.share-modal>
                <i class="bx bxs-share-alt font-size-16 align-middle mr-2"></i>
                Share Links
              </b-button>
            </div>
          </div>
        </div>
        <b-modal id="share-modal" ref="share-modal" title="Share Form" centered size="lg" hide-footer body-class="px-0">
          <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
            <b-tab active>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="bx bx-mail-send"></i>
                </span>
                <span class="d-none d-sm-inline-block">Email</span>
              </template>
              <b-form class="w-100 px-2" @submit.prevent="sendEmail">
                <b-form-group>
                  <label for="email">E-mail Address</label>
                  <b-input id="email" name="email" type="email" v-model="share.email" placeholder="Enter Email" :class="{ 'is-invalid': emailSubmitted && $v.share.email.$error }" />
                  <div v-if="emailSubmitted && $v.share.email.$error" class="invalid-feedback">
                    <span v-if="!$v.share.email.required">This value is required.</span>
                    <span v-if="!$v.share.email.email">Please enter valid email.</span>
                  </div>
                </b-form-group>
                <b-button variant="primary" class="w-md" type="submit">Send email</b-button>
              </b-form>
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="bx bx-link"></i>
                </span>
                <span class="d-none d-sm-inline-block">Link</span>
              </template>
              <div class="px-2">
                <b-alert
                  :show="share.dismissCountDown"
                  dismissible
                  variant="success"
                  @dismissed="share.dismissCountDown=0"
                  @dismiss-count-down="countDownChanged"
                >
                  Link Copied!
                </b-alert>
                <b-form-group class="w-100">
                  <label for="link">Link</label>
                  <b-input id="link" name="link" type="url" disabled :value="this.proposal ? this.proposal.landingPageUrl : null" />
                </b-form-group>
                <b-button @click="() => this.share.dismissCountDown = 5" variant="primary" class="w-md" v-clipboard:copy="this.proposal ? this.proposal.landingPageUrl : null">Copy Link</b-button>
              </div>
            </b-tab>
          </b-tabs>
        </b-modal>
        <div class="card-footer card-footer--border bg-white">
          <b-alert v-model="hasError" variant="danger" dismissible>Error - We are unable to {{ type }} this Proposal due to: {{ errors }}</b-alert>
          <div class="d-flex justify-content-end" v-if="!update || !proposal.deletedAt">
            <b-button
              variant="dark"
              v-if="!update || (update && proposal.status === 'Draft')"
              @click="() => update ? handleUpdate('Draft') : handleCreate('Draft')"
              :disabled="creating">
              <i class="bx bxs-save font-size-16 align-middle mr-2"></i>
              {{ this.update ? 'Update as Draft' : 'Create as Draft' }}
            </b-button>
            <div class="position-relative">
              <i v-if="creating" class="bx bx-loader-alt bx-spin text-white position-absolute font-size-20 py-2 px-5"></i>
              <b-button
                variant="primary"
                v-if="!update || (update && proposal.status === 'Draft')"
                @click="update ? handleUpdate('Active') : handleCreate('Active')"
                :disabled="creating"
                class="w-md ml-3">
                {{ this.update ? 'Update and Send' : 'Create and Send' }}
              </b-button>
            </div>
          </div>
          <p v-if="update && proposal.deletedAt" class="mb-0 font-italic text-primary py-2 text-right">Archived proposals can't be updated, please unarchive this proposal to update.</p>
        </div>
      </div>
    </div>
  </div>
</template>